import { objectHasKeys, isNull, isNullOrUndefined } from '@/utils/comparators'

/**
* Returns true if user has one or more saved credit cards
*/
const hasSavedCard = (state) => {
  if (isNull(state.cards)) {
    return false
  }

  return objectHasKeys(state.cards)
    ? Object.keys(state.cards).length > 0
    : false
}

const hasPrimaryCard = (state) => {
  if (isNull(state.cards)) {
    return false
  }

  return objectHasKeys(state.cards)
    ? Object.values(state.cards).filter((a) => a.isPrimary).length > 0
    : false
}

const isCardsReady = (state) => {
  if (isNull(state.cards)) {
    return false
  }

  return true
}

const getSavedCardsCount = (state) => {
  if (!state.cards) {
    return 0
  }
  return Object.keys(state.cards).length
}

const getSavedCards = (state) => {
  if (isNullOrUndefined(state.cards)) {
    return []
  }

  return Object.values(state.cards)
}

const getSelectedCard = (state, getters, rootState) => {
  if (isNullOrUndefined(state.cards)) {
    return false
  }
  return Object.values(state.cards).find((a) => a.id === rootState.checkoutV2.selectedPaymentMethod)
}

const getPrimaryCard = (state) => {
  if (hasPrimaryCard(state)) {
    return Object.values(state.cards).find((a) => a.isPrimary)
  }

  return null
}

export default {
  hasSavedCard,
  hasPrimaryCard,
  getSelectedCard,
  getSavedCardsCount,
  isCardsReady,
  getSavedCards,
  getPrimaryCard
}



// WEBPACK FOOTER //
// ./src/store/modules/user/wallet/getters.js